'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = require('./constants');

var _Scale = require('./Scale');

var _Scale2 = _interopRequireDefault(_Scale);

var _SlideIndex = require('./SlideIndex');

var _SlideIndex2 = _interopRequireDefault(_SlideIndex);

var _base = require('./themes/base');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Presentation = function (_Component) {
  _inherits(Presentation, _Component);

  function Presentation() {
    _classCallCheck(this, Presentation);

    return _possibleConstructorReturn(this, (Presentation.__proto__ || Object.getPrototypeOf(Presentation)).apply(this, arguments));
  }

  _createClass(Presentation, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var theme = this.props.theme;

      return {
        themeName: theme ? theme.props.name : null
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.$slides) return;
      this.scrollToSlide();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (!this.$slides) return;
      this.scrollToSlide();
    }
  }, {
    key: 'scrollToSlide',
    value: function scrollToSlide() {
      if (!this.$slides) return;
      var slideIndex = this.context.slideIndex;

      this.$slides.scrollTop = 700 * slideIndex;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          theme = _props.theme,
          props = _objectWithoutProperties(_props, ['children', 'theme']);

      var slideIndex = this.context.slideIndex;

      return _react2.default.createElement(
        'div',
        _extends({
          className: (0, _classnames2.default)(_constants.CLASS_NAMES.PRESENTATION, theme ? theme.props.name : null)
        }, props),
        _react2.default.createElement(
          _Scale2.default,
          {
            width: 960,
            height: 700,
            minScale: 0.2,
            maxScale: 1.5
          },
          _react2.default.createElement(
            'div',
            {
              className: _constants.CLASS_NAMES.SLIDES,
              ref: function ref(c) {
                _this2.$slides = c;
              }
            },
            children
          ),
          _react2.default.createElement(_SlideIndex2.default, {
            slideIndex: slideIndex,
            slideLength: [].concat(children).length
          })
        ),
        _base2.default,
        theme
      );
    }
  }]);

  return Presentation;
}(_react.Component);

Presentation.childContextTypes = {
  themeName: _react2.default.PropTypes.string
};

Presentation.contextTypes = {
  slideIndex: _react2.default.PropTypes.number.isRequired
};

exports.default = Presentation;


/*****************
 ** WEBPACK FOOTER
 ** ../lib/Presentation.js
 ** module id = 132
 ** module chunks = 0
 **/